// Boring Angular Modules //
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { GenericChooserComponent } from "./generic-chooser/generic-chooser.component";
import { MaterialModule } from "../material/material.module";
import { DynamicAutoCompleteService } from "../services/dynamic-autocomplete.service";



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  declarations: [
    GenericChooserComponent,
  ],
  exports: [
    GenericChooserComponent,
  ],
  providers: [
    DynamicAutoCompleteService
  ]
})
export class CustomFormControlsModule {}
